export enum LogistikAdvertisingMaterialCategory {
  CASCADE_LEARNING = 'Lernkaskade',
  REGISTRATION_FORM = 'Anmeldeformulare',
  FLYER = 'Flyer',
  POSTER = 'Poster',
  WRITING_PRODUCTS = 'Schreibprodukte',
  PAPER_PRODUCTS = 'Papierprodukte',
  BOOKMARKS = 'Lesezeichen',
  STICKER = 'Sticker',
  CARDS = 'Karten',
  MERCHANDISE = 'Merch',
}

export enum LogistikLearningMaterialCategory {
  GERMAN = 'Deutsch',
  MATH = 'Mathe',
  ENGLISH = 'Englisch',
  CHEMISTRY = 'Chemie',
  BIOLOGY = 'Biologie',
  EXPERTISE = 'Sachkunde',
  INTERDISCIPLINAR = 'Fachübergreifend',
}

export enum LogistikProductAvailability {
  AVAILABLE = 'sofort lieferbar',
  AVAILABLE_IN_1_TO_3_DAYS = 'versandfertig in 1-3 Tagen',
  AVAILABLE_IN_7_DAYS = 'versandfertig in 7 Tagen',
  AVAILABLE_IN_1_TO_2_WEEKS = 'versandfertig in 1-2 Wochen',
  AVAILABLE_IN_OVER_6_WEEKS = 'versandfertig in über 6 Wochen',
  UNAVAILABLE = 'nicht lieferbar',
}

export enum LogistikProductCategory {
  LEARNING_MATERIAL = 'Lernmaterial',
  ADVERTISING_MATERIAL = 'Werbematerial',
  WORK_MATERIAL = 'Büromaterial',
  TICKETS = 'Eintrittskarten',
  FURNISHING = 'Mobiliar',
  WORKSHOP_PACK = 'CHANCENakademie Workshop-Pakete',
  CHANCEN_BRIEF = 'FLYA',
  INDIVIDUAL = 'Individuelle Bestellung',
  TRAVEL_CERTIFICATE = 'CHANCENreise-Zertifikat',
  SET = 'CHANCENset',
  ENTIRE_TRIP = 'Fahrt und Unterkunft',
  OTHER = 'Sonstige',
}

export enum LogistikShippingStatus {
  PROCESSING = 'in Bearbeitung',
  SHIPPED = 'versendet',
  FORWARDED = 'an Lager weitergegeben',
  COMPLETED = 'abgeschlossen',
  PROBLEM = 'Problem',
  NEW = 'neu',
}

export enum LogistikShippingStatusIcon {
  PROCESSING = 'hourglass_empty',
  SHIPPED = 'local_shipping',
  COMPLETED = 'check_circle',
  PROBLEM = 'warning',
  NEW = 'new_releases',
  FORWARDED = 'factory',
}

export enum LogistikShippingMethod {
  MAIL = 'Post',
  DHL = 'DHL',
  DPD = 'DPD',
  UPS = 'UPS',
  HERMES = 'Hermes',
  AMAZON = 'Amazon',
  OTHER = 'sonstige Versandart',
  OTHER_NO_TRACKING = 'sonstige Versandart - kein Tracking',
  EMAIL = 'Email',
}

export enum LogistikShippingRecipient {
  SCHOOL = 'Schule',
  SCHUKO = 'SchuKo',
  SINGLE_PERSON = 'Einzelperson',
}

export enum LogistikOrderDeliveryStateEnum {
  RECEIVED = 'Bestellung erhalten',
  NOT_RECEIVED = 'Bestellung nicht erhalten',
  REQUESTED = 'Nachfrage gestellt',
  UNKNOWN = 'Unbekannt',
}

export enum LogistikMailTitles {
  PROCESSING = 'Ihre Bestellung wird bearbeitet',
  SHIPPED = 'Ihre Bestellung wurde versendet',
  COMPLETED = 'Ihre Bestellung wurde abgeschlossen',
  PROBLEM = 'Es gibt ein Problem mit Ihrer Bestellung',
  NEW = 'Wir haben Ihre Bestellung erhalten',
}

export enum LogistikProductTargetAudience {
  Kinder = 'Kinder',
  Jugendliche = 'Jugendliche',
  Übungsleitungen = 'Übungsleitungen',
  Erziehungsberechtigte = 'Erziehungsberechtigte',
  Schulen = 'Schulen',
  Chancenschulen = 'CHANCENschulen',
  Stiftungen = 'Stiftungen',
  Mitarbeitende = 'Mitarbeitende',
  LeseAdlerUndSchreibFüchse = 'LeseAdler und SchreibFüchse',
}

export enum LogistikProductBahncard {
  NO_BAHNCARD = 'Keine BahnCard',
  BAHNCARD_25 = 'BahnCard 25',
  BAHNCARD_50 = 'BahnCard 50',
}
// Bitte wie besprochen die drei Optionen als drop down Menü (wie auf der Seite der DB, unter 27, 27-65, über 65 ➝ bahn.de)
export enum LogistikTripAge {
  Under27 = 'Unter 27',
  Between27And65 = 'Zwischen 27 und 65',
  Over65 = 'Über 65',
}

export enum LogistikSchoolGrade {
  FIRST = '1. Klasse',
  SECOND = '2. Klasse',
  THIRD = '3. Klasse',
  FOURTH = '4. Klasse',
  FIFTH = '5. Klasse',
  SIXTH = '6. Klasse',
  SEVENTH = '7. Klasse',
  EIGHTH = '8. Klasse',
  NINTH = '9. Klasse',
  TENTH = '10. Klasse',
  ELEVENTH = '11. Klasse',
  TWELFTH = '12. Klasse',
  THIRTEENTH = '13. Klasse',
}

export enum LogistikURLParameters {
  Category = 'category',
  Search = 'search',
  Grade = 'grade',
  TargetAudiences = 'targetAudiences',
}

// ! Values match service names. Do not change. Follow the naming convention.
export enum Services {
  Hefte = 'chancenhefte',
  Logistik = 'chancenlogistik',
}
